import { render } from "./terminal.vue?vue&type=template&id=6b5eb800&scoped=true"
import script from "./terminal.vue?vue&type=script&lang=js"
export * from "./terminal.vue?vue&type=script&lang=js"

import "./terminal.vue?vue&type=style&index=0&id=6b5eb800&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5eb800"]])

export default __exports__